import { combineReducers } from 'redux';
import auth from './auth';
import interfaceComponents from './interface';
import scenario from './scenario';
import jobs from './jobs';
import i18n from './i18n';
import trade from './trade';
import tradeHistory from './tradeHistory';
import tradeCommission from './tradeCommission';
import account from './account';
import payment from './payment';
import activePayment from './activePayment';
import transfer from './transfer';
import simpleTransfer from './simpleTransfer';
import category from './category';
import transferCommission from './transferCommission';
import active from './active';
import dividend from './dividend';
import coupon from './coupon';
import obligation from './obligation';
import obligationPayment from './obligationPayment';
import insurance from './insurance';
import goal from './goal';
import goalItem from './goalItem';
import goalPlan from './goalPlan';
import valuation from './valuation';
import repo from './repo';
import couponDeal from './couponDeal';
import contract from './contract';
import activeMultiPayment from './activeMultiPayment';
import transferTradesApi from './transferTradesApi';
import spendingBudget from './spendingBudget';
import transferTrades from './transferTrades';
import convertTrade from './convertTrade';
import maintenance from './maintenance';

const rootReducer = combineReducers({
  auth,
  interfaceComponents,
  scenario,
  jobs,
  i18n,
  trade,
  tradeHistory,
  tradeCommission,
  account,
  payment,
  activePayment,
  activeMultiPayment,
  transfer,
  simpleTransfer,
  category,
  transferCommission,
  active,
  dividend,
  coupon,
  obligation,
  obligationPayment,
  insurance,
  goal,
  goalItem,
  goalPlan,
  valuation,
  repo,
  couponDeal,
  contract,
  transferTradesApi,
  spendingBudget,
  transferTrades,
  convertTrade,
  maintenance,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
